export enum ModalOrder {
  ACCEPT_TERMS_POPUP = 'accept-terms-popup',
  TUTORIAL_POPUP = 'tutorial-popup',
  CHARGE_TIMELINE_DAYS_POPUP = 'charge-timeline-days-popup',
}

export const MODAL_ORDER_LIST = [
  ModalOrder.ACCEPT_TERMS_POPUP,
  ModalOrder.TUTORIAL_POPUP,
  ModalOrder.CHARGE_TIMELINE_DAYS_POPUP,
];
